var cartNoteTyping;
var isUpdatingCart = false; // Flag to prevent race conditions

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

// --- Express Imprint Service (EXP-IMP) line sync -----------------------
// Whenever a box line's quantity changes or it is removed, mirror that
// onto its linked EXP-IMP line (if any), so the $100 service charge always
// tracks the quantity of Express-processed boxes it belongs to. The
// EXP-IMP line's own quantity/remove controls are removed in the cart
// template, so customers can only ever trigger this from the box side.
function findExpressBoxVariantId(cart, line) {
  var boxItem = cart.items[line - 1];
  if (!boxItem) return null;
  var props = boxItem.properties || {};
  if (props['_express_service'] === 'true') return null; // never sync from the service line itself
  return boxItem.variant_id || boxItem.id;
}

function findLinkedServiceLineIndex(cart, boxVariantId) {
  if (!boxVariantId) return null;
  for (var i = 0; i < cart.items.length; i++) {
    var props = cart.items[i].properties || {};
    if (props['_express_service'] === 'true' && String(props['_linked_to']) === String(boxVariantId)) {
      return i + 1;
    }
  }
  return null;
}

// Looks up the linked EXP-IMP line in the *current* cart (post the box's
// own change, so line indices are already up to date) and mirrors
// newQuantity onto it. quantity=0 removes it, matching Shopify semantics,
// which is what we want when the box itself was removed.
function syncLinkedExpressLine(boxVariantId, newQuantity, finalCallback, finalCallbackArg) {
  if (!boxVariantId) {
    finalCallback(finalCallbackArg);
    return;
  }
  jQuery.getJSON(cartUrl, function (freshCart) {
    var linkedLine = findLinkedServiceLineIndex(freshCart, boxVariantId);
    if (!linkedLine) {
      finalCallback(finalCallbackArg);
      return;
    }
    jQuery.ajax({
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + newQuantity + "&line=" + linkedLine,
      dataType: "json",
      success: function (updatedCart) {
        finalCallback(updatedCart);
      },
      error: function () {
        finalCallback(finalCallbackArg);
      },
    });
  });
}
// -------------------------------------------------------------------------

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

let convertShippingAmount = freeShippingBarAmount;

function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function logic(cart) {
  $("#mini__cart").click(function () {
    console.log("click");
  });
}

function freeShippingBar(cart, skipDiscountUpdate = false) {
  let countryAvailable = checkShippingAvailablity();
  let shippingBarContainer = $("[data-free-shipping-container]");
  let harvestCart = $("[data-harvest-cart]");
  let harvestCartShipping = $("[data-harvest-cart-shipping]");

  if (cart.item_count == 0) {
    harvestCart.addClass("hidden");
    harvestCartShipping.addClass("hidden");
    $("[data-drawer-title-customer]").text("Your Cart");
    document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    isUpdatingCart = false;
    return;
  }

  if (!countryAvailable || shippingBarContainer.length === 0) {
    isUpdatingCart = false;
    return;
  }

  if (countryAvailable && shippingBarContainer.length > 0) {
    harvestCart.removeClass("hidden");
    let cartPrice = cart.total_price;
    let harvestCustomer = $("[data-harvest-customer]").eq(0).text().trim();

    const progressBar = document.getElementById("progress-fill");
    const progressBarShipping = document.getElementById("progress-fill-shipping");
    const label = document.getElementById("label");
    const nextColor = document.getElementById("next-color");
    const nextColorShipping = document.getElementById("next-color-shipping");

    let cartValue = cart.total_price;
    let originalCartValue = cart.original_total_price;
    let discountApplied = cart.cart_level_discount_applications.length > 0;
    let currentDiscount = discountApplied ? cart.cart_level_discount_applications[0].title : null;

    if (discountApplied && originalCartValue >= 50000) {
        cartValue = originalCartValue;
    }

    // UPDATED THRESHOLDS
    const freeShippingThreshold = 49900; // $499.00
    const silverCartMax = 50000;         // $500.00
    const platinumCartMax = 150000;      // $1500.00

    // 1. Shipping bar logic (Standard Shipping Progress)
    if (cartValue < freeShippingThreshold) {
      $("[data-drawer-title]").text("Cart - Flat Rate Shipping");
      if (progressBarShipping) progressBarShipping.className = "express";
      if (nextColorShipping) nextColorShipping.className = "silver";
      if (document.getElementById("labela")) {
        document.getElementById("labela").innerHTML = `Only ${Shopify.formatMoney(freeShippingThreshold - cartValue, moneyFormat)} away from Free Shipping!`;
      }
    } else {
      $("[data-drawer-title]").text("Cart - Free Shipping");
      if (progressBarShipping) progressBarShipping.className = "silver";
      if (document.getElementById("labela")) {
        document.getElementById("labela").innerHTML = "Free Shipping!";
      }
    }

    // 2. Customer Tier & Discount Logic
    let targetDiscount = null;

    if (harvestCustomer == "HDCV1" || harvestCustomer == "HDCV2") {
      if (cartValue <= silverCartMax) {
        targetDiscount = null;

        if (cartValue < freeShippingThreshold) {
          $("[data-drawer-title-customer]").text("Standard Cart - Flat Rate Shipping");
          if (progressBar) progressBar.className = "express";
          if (nextColor) nextColor.className = "silver";
          if (label) label.innerHTML = `Only ${Shopify.formatMoney(freeShippingThreshold - cartValue, moneyFormat)} away from Free Shipping!`;
        } else if (cartValue <= silverCartMax) {
          // The $1 gap between Free Shipping ($499) and Silver ($500)
          $("[data-drawer-title-customer]").text("Silver Cart - Free Shipping");
          if (progressBar) progressBar.className = "silver";
          if (nextColor) nextColor.className = "gold";
          if (label) label.innerHTML = `Only ${Shopify.formatMoney(silverCartMax - cartValue, moneyFormat)} away from 10% off your entire order`;
        }

      } else if (cartValue <= platinumCartMax) {
        targetDiscount = "Gold Cart";
        $("[data-drawer-title-customer]").text("Gold Cart - 10% OFF + Free Shipping");
        if (progressBar) progressBar.className = "gold";

        if (harvestCustomer == "HDCV2") {
          if (nextColor) nextColor.className = "platinum";
          if (label) label.innerHTML = `Only ${Shopify.formatMoney(platinumCartMax - cartValue, moneyFormat)} away from 15% off your entire order`;
        } else {
          if (nextColor) nextColor.className = "";
          if (label) label.innerHTML = "You reached the Gold Cart!";
        }

      } else {
        if (harvestCustomer == "HDCV2") {
          targetDiscount = "Platinum Cart";
          $("[data-drawer-title-customer]").text("Platinum Cart - 15% OFF + Free Shipping");
          if (progressBar) progressBar.className = "platinum";
          if (nextColor) nextColor.className = "";
          if (label) label.innerHTML = "You reached the Platinum Cart!";
        } else {
          targetDiscount = "Gold Cart";
          $("[data-drawer-title-customer]").text("Gold Cart - 10% OFF + Free Shipping");
          if (progressBar) progressBar.className = "gold";
          if (nextColor) nextColor.className = "";
          if (label) label.innerHTML = "You reached the Gold Cart!";
        }
      }

      if (!skipDiscountUpdate && currentDiscount !== targetDiscount) {
        applyOrClearDiscount(targetDiscount);
      } else {
        isUpdatingCart = false;
      }
    } else {
      isUpdatingCart = false;
    }

    // 3. Progress bar visual width calculations
    let progressPercentage;
    let progressPercentageShipping;

    if (harvestCustomer == "HDCV1" || harvestCustomer == "HDCV2") {
      if (cartValue <= freeShippingThreshold) {
        progressPercentage = (cartValue / freeShippingThreshold) * 100;
      } else if (cartValue <= silverCartMax) {
        progressPercentage = 100; // Keep full for the small jump to Silver
      } else if (harvestCustomer == "HDCV2" && cartValue <= platinumCartMax) {
        progressPercentage = ((cartValue - silverCartMax) / (platinumCartMax - silverCartMax)) * 100;
      } else {
        progressPercentage = 100;
      }
    } else {
      progressPercentage = 0;
    }

    // Shipping bar fills at $499
    progressPercentageShipping = Math.min((cartValue / freeShippingThreshold) * 100, 100);

    if (progressBar) progressBar.style.width = `${progressPercentage}%`;
    if (progressBarShipping) progressBarShipping.style.width = `${progressPercentageShipping}%`;

    // Legacy support for older bar elements
    if ($("[data-free-shipping-bar]").length > 0) {
      $("[data-free-shipping-bar]").css("width", progressPercentageShipping + "%");
    }

    shippingBarContainer.removeClass("hidden");
  }
}

// Unified function to handle discount application/clearing
function applyOrClearDiscount(targetDiscount) {
  if (targetDiscount === null) {
    // Clear discount
    document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    fetch('/discount/CLEAR')
      .then(() => {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: {} }),
        });
      })
      .then(response => response.json())
      .then(updatedCart => {
        isUpdatingCart = false;
        updateCartDisplayOnly(updatedCart);
      })
      .catch(error => {
        console.error("Error clearing discount:", error);
        isUpdatingCart = false;
      });
  } else {
    // Apply discount
    const discountCode = targetDiscount.replace(/\s+/g, '%20');
    document.cookie = `discount_code=${discountCode}; path=/; max-age=3600`;

    fetch(`/discount/${discountCode}`)
      .then(() => {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: {} }),
        });
      })
      .then(response => response.json())
      .then(updatedCart => {
        isUpdatingCart = false;
        updateCartDisplayOnly(updatedCart);
      })
      .catch(error => {
        console.error("Error applying discount:", error);
        isUpdatingCart = false;
      });
  }
}

// Update display WITHOUT calling freeShippingBar recursively
function updateCartDisplayOnly(cart) {
  // Update cart totals
  $("[data-cart-item-count]").text(cart.item_count);
  $("[data-cart-original-price]").text(Shopify.formatMoney(cart.original_total_price, moneyFormat));
  $("[data-cart-total-price]").text(Shopify.formatMoney(cart.total_price, moneyFormat));

  // Update discount display
  if (cart.cart_level_discount_applications.length > 0) {
    var discounts = '';
    $.each(cart.cart_level_discount_applications, function(index, discount) {
      discounts += '<li data-cart-discount>Discount [' + discount.title + '] <strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong></li>';
    });
    $('li[data-cart-discount]').remove();
    $('li[data-cart-original]').removeClass('hidden');
    $(discounts).insertAfter('li[data-cart-original]');
  } else {
    $('li[data-cart-original]').addClass('hidden');
    $('li[data-cart-discount]').remove();
  }

  // Remove disabled states
  $(".media-link").removeClass("disabled");
  $(".cart-items-wrapper").removeClass("disabled");
  $("tr").removeClass("disabled");
  $("[data-cart-items]").removeClass("disabled");

  // Update ONLY the visual elements without triggering discount logic
  freeShippingBar(cart, true); // Pass true to skip discount updates
}

// Keep original updateCartDisplay for compatibility
function updateCartDisplay(cart) {
  updateCartDisplayOnly(cart);
}

var favicon = false;
function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  if (freeShippingBarStatus) {
    if (Shopify.currency.active != shopCurrency) {
      let shippingAmount = parseInt(freeShippingBarAmount);
      if (shippingAmount != undefined) {
        convertShippingAmount = parseFloat(
          (shippingAmount * Shopify.currency.rate).toFixed(2)
        );
      }
    }
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup ", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function (result) {},
    });
  }, 750);
});

if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations

  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");
        if (!country) {
          return false;
        }
        var shipping = new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "shippingProvince",
          {
            hideElement: "shippingProvinceContainer",
          }
        );

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#ShippingWrapperResponse")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          var shippingAddress = {};
          shippingAddress.zip = jQuery("#shippingZip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#shippingProvince").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };

    var _onError = function (XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#ShippingWrapperResponse")
        .html('<p class="error-text">' + feedback + "</p>")
        .addClass("error")
        .show();
    };

    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#ShippingWrapperResponse").html(html).addClass("success").show();
      } else {
        $("#ShippingWrapperResponse")
          .html('<p class="error-text">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };

    setTimeout(function () {
      shippingEstimates();
      $.ajax({
        url: mainCartUrl,
        type: "GET",
        dataType: "json",
        success: function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            upsellCartProducts(result);
          }
        },
      });
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();

  // Update quantity based on input on change

  changeCartItem = function (line, quantity) {
    jQuery.getJSON(cartUrl, function (preChangeCart) {
      var boxVariantId = findExpressBoxVariantId(preChangeCart, line);

      var params = {
        type: "POST",
        url: cartChangeUrl,
        data: "quantity=" + quantity + "&line=" + line,
        dataType: "json",
        success: function (cart) {
          if (cart.item_count == 0) {
            emptyCartStatus = true;
            $("[data-cart-count]").hide();
          } else {
            emptyCartStatus = false;
            cartItemsCount = cart.item_count;
            if (favicon) {
              favicon.badge(cartItemsCount);
            }
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }

          if (boxVariantId) {
            syncLinkedExpressLine(boxVariantId, quantity, cartPageUpdate, cart);
          } else {
            cartPageUpdate(cart);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            if (quantity == 0) {
              $('[name="updates[]"][data-line="' + line + '"]')
                .closest("tr")
                .remove();
            }
            cartItemsCount = cart.item_count;
            if (favicon) {
              favicon.badge(cartItemsCount);
            }
            if (cart.item_count == 0) {
              $("[data-cart-count]").hide();
            } else {
              $("[data-cart-count]").show();

              var item = cart.items[line - 1];
              if (item) {
                $('[name="updates[]"][data-line="' + line + '"]').val(
                  item.quantity
                );
              }
            }
            cartPageUpdate(cart);
          });
        },
      };
      jQuery.ajax(params);
    });
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]');

    $("#cartItemError-" + line).html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, ""));
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");

    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);

    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(line, 0);
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback) {
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          $("[data-cart-count]").show();
        }
        var item = cart.items[line - 1];
        if (item) {
          $(
            '.ajaxcart__qty-num[name="updates[]"][data-line="' + line + '"]'
          ).val(item.quantity);
        }

        // Remove disabled state immediately
        $(".media-link").removeClass("disabled");
        $(".cart-items-wrapper").removeClass("disabled");

        callback(cart);
      },
      error: function (XMLHttpRequest, textStatus) {
        $(".media-link").removeClass("disabled");
        $(".cart-items-wrapper").removeClass("disabled");
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          callback(cart);
        });
      },
    };
    jQuery.ajax(params);
  };

  updateQuantity = function (line, qty, callback) {
    jQuery.getJSON(cartUrl, function (preChangeCart) {
      var boxVariantId = findExpressBoxVariantId(preChangeCart, line);
      changeItem(line, qty, function (cart) {
        if (boxVariantId) {
          syncLinkedExpressLine(boxVariantId, qty, callback, cart);
        } else {
          callback(cart);
        }
      });
    });
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }

  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", function (evt) {
      evt.preventDefault();

      let submit = $(this);
      let form = $(this).closest("form");

      var hasFileInput = false
      if (form.find('[type="file"]').length){
        hasFileInput = true;
      }

      if (submit.hasClass("Sd_addProductSticky")) {
        form = jQuery("#" + submit.attr("form"));
      }
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        focusElement = submit;
      }
      let parentSection = form.closest(".shopify-section");
      var Email = $('input[data-attr="' + "email" + '"]').val();
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
      parentSection.find(".productErrors").hide().html("");
      submit.addClass("is-loading");
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").find("[data-side-drawer]").attr("id", "mini__cart");
        $("body").find("[data-side-drawer]").addClass("mini_cart");
      }

      var formData = new FormData(document.querySelector('form'))
      params = {
        type: "POST",
        url: cartAddUrl,
        data: form.serialize(),
        dataType: "json",
        success: function (line_item) {
          if (form.closest(".yv_side_drawer_wrapper").length > 0) {
            $("[data-drawer-body]").html(preLoadLoadGif);
            $("body")
              .find("[data-side-drawer]")
              .attr("class", "yv_side_drawer_wrapper");
            $("body").find("[data-drawer-title]").html(cartTitleLabel);
            $("body").find("[data-side-drawer]").attr("id", "mini__cart");
            $("body").find("[data-side-drawer]").addClass("mini_cart");
          }

          $("body").removeClass("quickview-open");
          $("body").addClass("side_Drawer_open");
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            buildCart(cart, true);
            setTimeout(function () {
              submit.removeClass("is-loading");
            }, 1000);
          });
        },
        error: function (XMLHttpRequest, textStatus) {
          focusElement = "";
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            let errorContainer = parentSection.find(".productErrors");
            if (errorContainer.length > 0) {
              if (XMLHttpRequest.responseJSON.errors) {
                let giftCardWrapper = form.find("[data-gift-card-box]");
                if (
                  giftCardWrapper.length > 0 &&
                  XMLHttpRequest.responseJSON.errors["email"]
                ) {
                  let errormessageWrapper = giftCardWrapper.find(
                    "[data-gift-card-errors]"
                  );
                  let giftCardEmail = giftCardWrapper.find("[type=email]");
                  errorContainer
                    .html(
                      giftCardEmail.attr("data-attr") +
                        " " +
                        XMLHttpRequest.responseJSON.errors["email"]
                    )
                    .show();
                }
              } else {
                errorContainer
                  .html(XMLHttpRequest.responseJSON.description)
                  .show();
              }
            }
          }
          setTimeout(function () {
            $(".Sd_addProductSticky").removeClass("is-loading");
            submit.removeClass("is-loading");
          }, 1000);
        },
      };

      jQuery.ajax(params);
    });

    // Update quantity based on input on change
    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      if (isUpdatingCart) return;
      isUpdatingCart = true;

      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }

      var qty = validateQty(qty);

      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      if (line) {
        updateQuantity(line, qty, buildCart);
      } else {
        isUpdatingCart = false;
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      if (isUpdatingCart) return;
      isUpdatingCart = true;

      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);

      if (line) {
        updateQuantity(line, qty, buildCart);
      } else {
        isUpdatingCart = false;
      }
    });

    function openCartDrawer(element) {
      $("[data-drawer-body]").html(preLoadLoadGif);
      $("body").find("[data-drawer-title]").html(cartTitleLabel);
      $("body")
        .find("[data-side-drawer]")
        .attr("class", "yv_side_drawer_wrapper");
      $("body")
        .find("[data-side-drawer]")
        .attr("id", "mini__cart")
        .addClass("mini_cart");
      $("body").addClass("side_Drawer_open");
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        buildCart(cart, true, element);
      });
    }

    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line"));
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (line) {
        updateQuantity(line, 0, buildCart);
      }
    });

    $(document).on("click ", ".cartDrawerNote", function (evt) {
      $(this).toggleClass("active");
      var textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });
  }
}

$("body").on("click", "#GiftWrapProduct", function () {
  params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: parseInt($(this).attr("data-product")), quantity: 1 },
    dataType: "json",
    success: function (line_item) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          buildCart(cart, true);
        } else {
          cartPageUpdate(cart);
        }
      });
    },
  };
  jQuery.ajax(params);
});

cartPageUpdate = function (cart) {
  $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      $(".cart-section").find("a:first").trigger("focus");
      freeShippingBar(cart);
      logic(cart);
      upsellCartProducts(cart);
      window.shippingEstimates();
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

buildCart = function (cart, showCart, element) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if (favicon) {
    favicon.badge(cartItemsCount);
  }

  $("[data-drawer-body]").load(mainCartUrl + "?view=jsonData", function () {
    freeShippingBar(cart);
    upsellCartDrawerProducts(cart, "drawer");
    isUpdatingCart = false; // Reset flag after load completes

    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
    }
    if (animationStatus && typeof AOS !== 'undefined') {
      AOS.refreshHard();
    }
  });
};

$(document).on("click", "[data-drawer-side-header]", function () {
  if ($(this).closest(".yv-upsell-drawer").hasClass("active")) {
    $(this).closest(".yv-upsell-drawer").removeClass("active");
  } else {
    $(this).closest(".yv-upsell-drawer").addClass("active");
  }
});

function upsellCartDrawerProducts(cart) {
  if (cart.item_count != 0) {
    if (document.querySelector("[data-drawer-side-content]")) {
      let upsellContainer = document.querySelector(
        "[data-drawer-side-content]"
      );
      let intent = upsellContainer.getAttribute("data-related-products");
      if (intent != "product-list") {
        let productId = cart.items[0].product_id;
        let limit = upsellContainer.getAttribute("data-limit");
        fetch(
          window.Shopify.routes.root +
            "recommendations/products?product_id=" +
            productId +
            "&limit=" +
            limit +
            "&section_id=upsell-products&intent=" +
            intent
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "#product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              upsellContainer.innerHTML = recommendations.innerHTML;
              document
                .querySelector(".yv-upsell-drawer")
                .classList.remove("hidden");
            } else {
              document
                .querySelector(".yv-upsell-drawer")
                .classList.add("hidden");
            }
          });
      } else {
        if (upsellContainer.children.length > 0) {
          document
            .querySelector(".yv-upsell-drawer")
            .classList.remove("hidden");
        } else {
          document.querySelector(".yv-upsell-drawer").classList.add("hidden");
        }
      }
    }
  }
}

function upsellCartProducts(cart) {
  if (cart.item_count != 0) {
    if (document.querySelector("[data-cart-upsell-wrapper]")) {
      let upsellWrapper = document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer = upsellWrapper.querySelector("[data-cart-upsell]");
      let intent = upsellWrapper.getAttribute("data-related-products");
      if (intent != "product-list") {
        let productId = cart.items[0].product_id;
        let limit = upsellWrapper.getAttribute("data-limit");
        fetch(
          window.Shopify.routes.root +
            "recommendations/products?product_id=" +
            productId +
            "&limit=" +
            limit +
            "&section_id=upsell-products&intent=" +
            intent
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "#product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              if (window.innerWidth >= 768) {
                if (upsellContainer.classList.contains("flickity-enabled")) {
                  let slider = Flickity.data(upsellContainer);
                  if (slider) {
                    slider.destroy();
                    upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove("hidden");
                    flickitySlider(jQuery(upsellContainer));
                  }
                } else {
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove("hidden");
                  flickitySlider(jQuery(upsellContainer));
                }
              } else {
                upsellContainer.innerHTML = recommendations.innerHTML;
                upsellWrapper.classList.remove("hidden");
              }
            } else {
              upsellWrapper.classList.add("hidden");
            }
          });
      } else {
        if (upsellContainer.classList.contains("flickity-enabled")) {
          let slider = Flickity.data(upsellContainer);
          if (slider) {
            slider.destroy();
          }
        }
        if (upsellContainer.children.length > 0) {
          if (window.innerWidth >= 768) {
            upsellWrapper.classList.remove("hidden");
            flickitySlider(jQuery(upsellContainer));
          } else {
            upsellWrapper.classList.remove("hidden");
          }
        } else {
          upsellWrapper.classList.add("hidden");
        }
      }
    }
  }
}